// extracted by mini-css-extract-plugin
export var subscribe = "subscribeContainer-module--subscribe--35cjv";
export var textWrap = "subscribeContainer-module--textWrap--2w6ap";
export var title = "subscribeContainer-module--title--26xQj";
export var subtitle = "subscribeContainer-module--subtitle--3c7ob";